export default __webpack_public_path__ + "static/media/crt_20_anos.a3308d0e.png";